import { Box, BoxProps, ColorOptions, Spacer, Text } from '@jfs/ui-new'
import { ButtonNew } from '../../components/AdminButton'
import { useState } from 'react'
import { Dropdown } from '../../components/Dropdown'

export const EditPackageToMid = ({ packageName, update, close, packageNames }: any) => {
  const [value, setValue] = useState<string>()

  return (
    <Box bg={'TRANSPARENT'} w={'50%'} alignSelf={'center'}>
      <Box {...styles.container} bg={'#f8f9fc' as ColorOptions}>
        <Text fontFamily="jiotype-bold" color={'#214796' as ColorOptions} fontSize={16} title={'Edit Package Data'} />
        <ButtonNew
          title={'Close'}
          onPress={close}
          height={30}
          color={'ERROR'}
          borderRadius={4}
          underlayColor={'TRANSPARENT'}
          hoverColor={'ERROR'}
        />
      </Box>
      <Box {...styles.listContainer}>
        <Dropdown
          title={value ?? packageName}
          label={'Package Name*'}
          data={packageNames}
          selectedData={setValue}
          minWidth={200}
        />
        <Spacer direction={'vertical'} size={16} />
        <Box align={'flex-end'}>
          <ButtonNew
            title={'Update'}
            underlayColor={'TRANSPARENT'}
            onPress={() => update(value)}
            height={36}
            color={'GREEN'}
            borderRadius={4}
            icon={'UPLOAD'}
            width={96}
            disabled={!value || value === packageName}
          />
        </Box>
      </Box>
    </Box>
  )
}

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 1,
    height: 1,
  },
  shadowOpacity: 0.1,
  shadowRadius: 4,
  zIndex: 10,
}

const styles = {
  container: {
    ...shadow,
    underlayColor: 'WHITE',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 14,
    borderWidth: 1,
    borderRadius: 4,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: '#e3e6f0' as ColorOptions,
  } as BoxProps,
  listContainer: {
    ...shadow,
    backgroundColor: 'WHITE',
    padding: 16,
    underlayColor: 'WHITE',
    borderColor: '#e3e6f0' as ColorOptions,
    borderWidth: 1,
    borderTopWidth: 0,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
  } as BoxProps,
}
